import ToolingManagementMenu from './ToolingManagementMenu';

export default ToolingManagementMenu;



// WEBPACK FOOTER //
// ./src/components/ToolingManagementMenu/index.jsx